import React, { useEffect } from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import FilteredModules from 'federation/FilteredModules';
import { useComplementaryModule } from '../../../hooks/useComplementaryModule';
import { useNavigate } from 'react-router-dom';
import { RouteEnum } from '../../../constantes/RouteEnum';
import PageContainer from '../../../components/PageContainer/PageContainer';
import { pageConfigs } from '../../../configs/pageConfigs';

const ComplementaryStep: React.FC = () => {
  const { getComplementaryProps, isComplementaryStepRequired } = useComplementaryModule();
  const navigate = useNavigate();


  // Só carrega o módulo se o passo complementar for necessário
  const shouldLoadModule = isComplementaryStepRequired();
  const complementaryProps = getComplementaryProps();

  // Função para teste - navega direto para o finish
  const handleTestFinish = () => {
    navigate(RouteEnum.FINISH);
  };
  
  
  // Se não carregar o MFE, usa o DynamicForm com PageContainer completo
  if (!shouldLoadModule) {
    return (
      <DynamicForm 
        pageName="complementaryStep"
        initialValues={ApiLocalStorage.get('user-data')} 
      />
    );
  }
  
  // Se carregar o MFE, usa apenas o FilteredModules no meio
  return (
    <PageContainer
      title={pageConfigs.complementaryStep.title}
      navigateClose={false}
    >
      {/* MFE carregado no meio da página */}
      <FilteredModules 
        componentName="complementary" 
        props={complementaryProps}
      />
    </PageContainer>
  );
};

export default ComplementaryStep; 